export const breakpoints = {
  mobile: 0,
  largeMobile: 480,
  tablet: 768,
  laptop: 1024,
  desktop: 1440,
  wideDesktop: 1920,
} as const

export const mediaQueries = {
  mobile: '(max-width: 479px)',
  largeMobile: '(min-width: 480px) and (max-width: 767px)',
  tablet: '(min-width: 768px) and (max-width: 1023px)',
  desktopMotion: '(min-width: 1024px)',
  wideDesktop: '(min-width: 1920px)',
  landscapeMobile: '(orientation: landscape) and (max-height: 500px)',
  reducedMotion: '(prefers-reduced-motion: reduce)',
} as const
